import styled from './index.module.scss';
import { JpEcoCreditsIcon, JpEcoCreditsIconH5 } from './JpEcoCreditsIcon';

function formatNumberWithCommas(number: number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export const JpEcoCredits = ({ multiple, points }: { multiple: string; points: number }) => {
    return (
        <div className={`${styled.JpEcoCredits}`}>
            <div className="center">
                <div className="text">
                    <span>{multiple}倍</span>
                    <span>{formatNumberWithCommas(points)}ポイント</span>
                </div>
                <div className="icon-wrapper-pc">
                    <JpEcoCreditsIcon />
                </div>
                <div className="icon-wrapper-h5">
                    <JpEcoCreditsIconH5 />
                </div>
            </div>
        </div>
    );
};
